export default __webpack_public_path__ + "static/collective-ai-dark-9fdcb458f06a8f83e0831663335b46ce.png";